<template>
  <div class="question1">
    <div class="question1_container">
      <h4 class="bold colorWhite">請輸入你家地址</h4>
      <select v-model="selected1" @change="onChange1" class="t">
        <option disabled selected hidden>{{ selected1 }}</option>
        <option v-for="(option, index) in options1" selected :key="index">{{ option.CityName }}</option>
      </select>
      <br>
      <hr>
      <select v-model="selected2" @change="onChange2">
        <option disabled selected hidden>{{ selected2 }}</option>
        <option v-for="(option, index) in options2" selected :key="index">{{ option.AreaName }}</option>
      </select>
      <br>
      <hr>
      <select v-model="selected3" @change="onChange3">
        <option disabled selected hidden>{{ selected3 }}</option>
        <option v-for="(option, index) in options3" selected :key="index">{{ option.RoadName }}</option>
      </select>
      <hr>
      <router-link to="/question2" class="question1_container_btn bold" :class="{'question1_container_btn-active': btnIsActive}" title="下一題">下一題</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Question1',
  props: {
    bar: Object
  },
  data() {
    return {
      selected1: '請選擇縣市',
      selected2: '請選擇鄉鎮市區',
      selected3: '道路或街名',
      options1: require('../../public/static/cityData.json')
    }
  },
  computed: {
    options2() {
      // for (let i=0;i<this.options1.length;i++) {
      //   if (this.options1[i].CityName === this.selected1) {
      //     return this.options1[i].AreaList
      //   }
      // }
      let vm = this
      let array = vm.options1.find(function(item, index){
        return item.CityName === vm.selected1
      })
      if(array){ return array.AreaList }
      return []
    },
    options3() {
      // for (let i=0;i<this.options2.length;i++) {
      //   if (this.options2[i].AreaName === this.selected2) {
      //     return this.options2[i].RoadList
      //   }
      // }
      let vm = this
      let array = vm.options2.find(function(item, index){
        return item.AreaName === vm.selected2
      })
      if(array){ return array.RoadList }
      return []
    },
    btnIsActive() {
      if (this.selected3 !== '道路或街名') {
        return true
      }
      return false
    },
    isWeb(){
      if(window.innerWidth >= 768){
        return true
      }
      return false
    }
  },
  methods: {
    onChange1() {
      this.selected2 = '請選擇鄉鎮市區'
      this.selected3 = '道路或街名'
    },
    onChange2() {
      this.selected3 = '道路或街名'
    },
    onChange3() {
      this.$store.state.answers.answer1 = this.selected1 + this.selected2 + this.selected3
      // console.log('$answer1: ' + this.$store.state.answers.answer1)
    }
  },
  mounted() {
    if(this.bar){
      this.bar._container.parentNode.style.opacity = 1
      this.bar.animate(.2)
      this.bar.text.textContent = '1/5'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
h4
  padding: 2rem 0
hr
  margin: 2rem 0
  border: none
  border-top: 1px solid #A9A9A9
  animation: ani 1s
select
  background: #737373
  border: none
  padding: 10px 0px 10px 0px
  min-width: 250px
  color: #fff
  text-align-last: center
  animation: ani 1s
  &:focus 
    outline: #57af9f auto 1px
option:hover
  outline: #57af9f auto 1px
.bold
  font-weight: bold
.colorWhite
  color: #fff
.question1
  width: 100%
  min-height: 100vh
  display: flex
  justify-content: center
  align-items: flex-start
  margin: 0 auto
  background: #5b5b5b
  height: 100vh
  @media (min-width: 768px) 
    align-items: flex-end
  @media (min-width: 1280px) 
    width: 880px
    padding: 0 10% 0 10%
    box-sizing: content-box
    height: 100vh
.question1_container
  min-height: 100vh
  overflow: auto
  margin: 0 auto
  width: 100%
  height: 100%
  padding: 50px 1rem 0 1rem
  text-align: center
  background-color: #737373
  box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, 0.16)
  border-radius: 10px 10px 0 0
  @media (min-width: 768px) 
    width: 880px
    min-height: auto
    height: calc(100% - 100px)
.question1_container_btn
  display: inline-block
  padding: 5px 5rem
  color: #cfcfcf
  box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, 0.16)
  background-color: #A9A9A9
  text-decoration: none
  font-size: 1.25rem
  pointer-events: none
  margin: 1rem 0
  opacity: 0
  animation: ani 1s 0.5s forwards
.question1_container_btn-active
  pointer-events: auto
  color: #fff
  background-color: #57af9f
@keyframes ani 
  0%
    transform: translateY(50px)
    opacity: 0
  100%
    transform: translateY(0)
    opacity: 1
</style>
